import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { updateFacetValues, getSelectedFacetNameFirstAttribute } from 'selectors/algolia2/facets'
import { getBrowseHitsPerPage } from '../selectors/app'
import { hasPrintsSelected, updateCategoryFacetValues } from '../selectors/facets'
import { getAlgoliaDataHitsTotal } from 'selectors/algolia2/data'
import { getHrefFunction } from 'connectors/Facets/helper'

const mapStateToProps = createStructuredSelector({
  category: (state, ownProps) => getSelectedFacetNameFirstAttribute('category')(state),
  getHref: getHrefFunction,
  hitsPerPage: getBrowseHitsPerPage,
  updateFacetValues: (state) => {
    // Availability to Add/Remove facet from a LIST
    return (facetName: string, facetValue: string) => {
      return updateFacetValues(facetName, facetValue)(state)
    }
  },
  updateCategoryFacetValues: (state) => {
    return (facetName: string, facetValue: string) => {
      return updateCategoryFacetValues(facetName, facetValue)(state)
    }
  },
  totalHits: getAlgoliaDataHitsTotal,
  hasPrints: hasPrintsSelected,
})

export type ConnectorProps = {
  category: string
  getHref: (...args: Array<any>) => any
  hitsPerPage: number
  updateCategoryFacetValues: (...args: Array<any>) => any
  updateFacetValues: (...args: Array<any>) => any
  totalHits: number
  hasPrints: boolean
}

export default connect(mapStateToProps)
